{
  "all": [
    {
      "id": "responsabilidad-civil",
      "title": "Responsabilidad Civil",
      "description": "Garantiza hasta 70 millones de euros por siniestro en el caso de daños personales y hasta 15 millones en el caso de daños materiales, la obligación de indemnizar derivada de un accidente por hechos de la circulación , para el conductor y/o propietario del vehículo asegurado especificado en la póliza, según lo establecido en el artículo 1902 y sucesivos del Código Civil, artículos 109 y sucesivos del Código Penal."
    },
    {
      "id": "accidentes-conductor",
      "title": "Accidentes del Conductor",
      "description": "Están cubiertos los siguientes capitales fijos:<br/>Muerte: 9.000 €.<br/>Invalidez: 9.000.€<br/>Asistencia sanitaria: libre elección 3.000€, e ilimitada en centros concertados."
    },
    {
      "id": "proteccion-juridica",
      "title": "Protección Jurídica",
      "description": "Esta garantía te ofrece la posibilidad de contar con la opinión o aclaración de un profesional, incluso necesitar los servicios de un abogado capaz de proteger nuestros propios intereses en el caso que no se cumplan nuestros derechos."
    }
  ],
  "optional": [
    {
      "id": "asistencia-carretera",
      "title": "Asistencia en carretera",
      "description": "Servicio de grúa en caso de avería o accidente.<br/>El servicio de asistencia en carretera tiene una carencia de 24 horas a partir de la fecha de contratación.<br/>En España desde el kilómetro 0  y en todos los países de Europa, y el resto de países ribereños del Mediterráneo.<br/>Cobertura hasta un máximo de 600€."
    }
  ]
}
